export default __webpack_public_path__ + "static/media/ico_legal.042b507c.svg";